import { observer } from 'mobx-react';
import React, { useMemo } from 'react';

import { useSelectVehicles } from '@hooks';
import { L } from '@lib';
import { Select } from 'antd';

interface IProps {
  placeholder?: string;
  mode?: 'multiple' | 'tags';
  status?: 'error' | 'warning';
  stickyHeader?: boolean;
  onClear?: () => void;
  onSelect?: (id: string) => void;
  onDeselect?: (id: string) => void;
}

export const VehicleSelect: React.FC<IProps> = observer(
  ({ status, stickyHeader, onSelect, onDeselect }) => {
    const { vehicles, handleSearch } = useSelectVehicles();

    const options = useMemo(() => {
      return vehicles.map((vehicle) => ({
        label: vehicle.registrationNumber,
        value: vehicle.id,
      }));
    }, [vehicles]);

    return (
      <Select
        allowClear
        showSearch
        notFoundContent={null}
        filterOption={false}
        style={{ width: '100%' }}
        status={status}
        options={options}
        onSelect={onSelect}
        onSearch={handleSearch}
        onDeselect={onDeselect}
        placeholder={L('Enter registration number here')}
        getPopupContainer={(stickyHeader && ((trigger: any) => trigger.parentElement)) || undefined}
      />
    );
  }
);
